// src/utils/dialog.js — themed, promise-based confirm/prompt/alert to replace
// the browser's native window.confirm/prompt/alert (which render as an ugly
// "system is asking you a question" dialog inside the Android WebView).
// A single <DialogHost/> mounted in App registers the handler; these helpers
// dispatch to it and resolve when the user responds.

let handler = null;
export function registerDialogHandler(fn) { handler = fn; return () => { handler = null; }; }

// confirm({ title, message, confirmText, cancelText, danger }) → Promise<boolean>
export function confirmDialog(opts = {}) {
  if (!handler) return Promise.resolve(window.confirm(opts.message || opts.title || 'Are you sure?'));
  return new Promise(resolve => handler({ kind: 'confirm', ...opts, resolve }));
}

// promptDialog({ title, message, placeholder, defaultValue }) → Promise<string|null>
export function promptDialog(opts = {}) {
  if (!handler) return Promise.resolve(window.prompt(opts.message || opts.title || '', opts.defaultValue || ''));
  return new Promise(resolve => handler({ kind: 'prompt', ...opts, resolve }));
}

// alertDialog({ title, message }) → Promise<void>
export function alertDialog(opts = {}) {
  if (!handler) { window.alert(opts.message || opts.title || ''); return Promise.resolve(); }
  return new Promise(resolve => handler({ kind: 'alert', ...opts, resolve }));
}
